import { useState } from "react";

import { Anchor, Button, Checkbox, InfoModal, PlusSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  addIconCss,
  customActivitiesCss,
  headerSectionCss,
  modalFooterButtonRowCss,
  modalFooterCss,
  modalTitleCss,
  titleSectionCss,
  viewActivitiesLinkCss,
  addActivityCard,
  addActivityButtonCss,
  activityListContainerCss,
  activitylistItemCss,
  checkboxStyles,
} from "./ActivitySelectionModal.style";

const propTypes = {
  /**
   * Array of Assignment activities
   */
  assignmentActivities: PropTypes.array,
  /**
   * Array of the previous selected array of activities
   */
  selectedStepActivities: PropTypes.array,
  /**
   * URL to view the content
   */
  contentViewUrl: PropTypes.string,
  /**
   * Callback to update the selected activities
   */
  updateSelectedActivities: PropTypes.func,
  /**
   * Additional styles for the Activities step modal
   */
  __cssFor: PropTypes.object,
  /**
   * Props for Activity List Modal
   */
  activitiesModalProps: PropTypes.object,
  /**
   * Set Active for activities modal
   */
  activitiesModalSetActive: PropTypes.func,
  /**
   * Element Ref to trigger to return position back
   */
  activitiesModalTriggerRef: PropTypes.any,
};

const ActivitySelectionModal = ({
  assignmentActivities,
  selectedStepActivities,
  updateSelectedActivities,
  contentViewUrl,
  __cssFor,
  activitiesModalProps,
  activitiesModalSetActive,
  activitiesModalTriggerRef,
}) => {
  const [selectedActivities, setSelectedActivities] = useState([]);
  const subjects = [
    ...new Set(assignmentActivities.map((curr) => curr?.subject)),
  ].sort();

  const isActivityChecked = (activity) =>
    !!selectedActivities.find(
      (selectedActivity) => selectedActivity.id === activity.id,
    );
  const selectActivityChoice = (activityChoice) => {
    const isChecked = isActivityChecked(activityChoice);
    let previousActivities = [...selectedActivities];
    if (isChecked) {
      previousActivities = previousActivities.filter(
        (current) => current.id !== activityChoice.id,
      );
    } else {
      previousActivities = [...previousActivities, activityChoice];
    }
    setSelectedActivities(previousActivities);
  };
  const postStepActivities = () => {
    updateSelectedActivities(selectedActivities);
    activitiesModalSetActive(false);
  };

  return (
    <div css={addActivityCard}>
      <Button
        __cssFor={{
          root: addActivityButtonCss,
          Icon: { root: addIconCss },
        }}
        flavor={Button.flavors.tertiary}
        onClick={() => {
          setSelectedActivities(selectedStepActivities);
          activitiesModalSetActive(true);
        }}
        isIconBeforeText="true"
        icon={{
          SvgComponent: PlusSVG,
          alignment: Button.iconAlignments.left,
        }}
        ref={activitiesModalTriggerRef}
      >
        Add Activity
      </Button>
      <InfoModal
        labelId="Activities"
        title="Add Activities"
        {...activitiesModalProps}
        __cssFor={{
          title: modalTitleCss,
          footer: modalFooterCss,
          ...__cssFor,
        }}
        footer={
          <div css={modalFooterButtonRowCss}>
            <Button
              flavor={Button.flavors.secondary}
              onClick={() => {
                activitiesModalSetActive(false);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                postStepActivities();
              }}
            >
              {selectedStepActivities.length
                ? "Update activities"
                : "Add activities"}
            </Button>
          </div>
        }
      >
        <div css={headerSectionCss}>
          <div>Select activities</div>
          <Anchor
            href={`${contentViewUrl}/activities?preview_for=assignment`}
            aria-label="View all activities"
            openInNewTab
            __cssFor={{
              root: viewActivitiesLinkCss,
            }}
          >
            View all activities
          </Anchor>
        </div>
        {subjects.map((subject) => {
          const activitiesBySubject = assignmentActivities.filter(
            (activity) => activity?.subject === subject,
          );
          return (
            <section css={customActivitiesCss} key={subject}>
              <h5 css={titleSectionCss}>{subject}</h5>
              <ul css={activityListContainerCss}>
                {activitiesBySubject.map((activityChoice) => (
                  <li key={activityChoice.id} css={activitylistItemCss}>
                    <Checkbox
                      __cssFor={{ root: checkboxStyles }}
                      checked={isActivityChecked(activityChoice)}
                      label={activityChoice.name}
                      name="activity"
                      value={activityChoice.name}
                      onClick={() => selectActivityChoice(activityChoice)}
                    />
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </InfoModal>
    </div>
  );
};

ActivitySelectionModal.propTypes = propTypes;
export default ActivitySelectionModal;
